<template>
	<window-view title="Migrer enhed" v-on="$listeners" :width="400" :actions="_actions">
		<panel-view>
			<panel-sep-view>
				<grid-view>
					<input-view v-model="m.new_id" :options="_organisations" label="Enheds ID" />
				</grid-view>	
				<grid-view>
					<select-view v-model="m.organisationId" :options="_organisations" label="Organisation (destination)" />
				</grid-view>			
			</panel-sep-view>
		</panel-view>
	</window-view>
</template>

<script>
	import client from '../../../model/client';

	export default {
		props: ['model'],
		data() {
			return {
				id: '',
				m: {
					...client.model(),
					organisationId: '',
				},
				organisations: [],
				submit(model) {
					return client.save(model);
				}
			};
		},
		computed: {
			_actions() {
				const self = this;

				return [
					{
						label: 		'Annuller',
						emphasis: 	'text',
						action:		() => true
					},
					{
						label: 		'Gem',
						action: 	async () => {
							// Anyhting missing?
							if (!this.m.new_id || !this.m.organisationId) {
								alert('Udfyld alle felter');
								return false;
							}

							// Check if device ID exists
							try {
								await this.axios.get(`/devices/${this.m.new_id}`);
								alert('Enheden findes allerede på destinationen');
								return false;
							} catch (e) {
								// Nothing
							}

							// Get data for device
							const device = (await this.axios.get(`/migration/devices/${this.m.new_id}`)).data;

							this.m.username = device.username;
							this.m.password = device.password;

							console.log({
								device
							});

							// Create device if not found
							if (await self.submit(this.m)) {
								// Save activity
								const batch = [];

								while (device.activity.length > 0) {
									const activity = device.activity.shift();
									const json = JSON.parse(activity.payload);

									batch.push({
										deviceId: this.m.new_id,
										logged: isNaN(Date.parse(json.timestamp)) ? new Date(0).toISOString() : new Date(json.timestamp).toISOString(),
										type: json.call || 'unknown',
										weight: typeof json.weight === 'number' || (typeof json.weight === 'string' && !isNaN(Number(json.weight))) ? Number(json.weight) : 0,
										csq: json.device && (typeof json.device.csq === 'number' || (typeof json.device.csq === 'string' && !isNaN(Number(json.device.csq)))) ? Number(json.device.csq) : 0,
										cops: json.device && typeof json.device.cops === 'string' ? json.device.cops : '',
										temp: typeof json.temp === 'number' || (typeof json.temp === 'string' && !isNaN(Number(json.temp))) ? Number(json.temp) : 0,
										signal: json.radio && (typeof json.radio.signal === 'number' || (typeof json.radio.signal === 'string' && !isNaN(Number(json.radio.signal)))) ? Number(json.radio.signal) : 0,
										ratio: json.radio && (typeof json.radio.ratio === 'number' || (typeof json.radio.ratio === 'string' && !isNaN(Number(json.radio.ratio)))) ? Number(json.radio.ratio) : 0,
										batteryLevel: json.battery && (typeof json.battery.level === 'number' || (typeof json.battery.level === 'string' && !isNaN(Number(json.battery.level)))) ? Number(json.battery.level) : 0,
										batteryVoltage: json.battery && (typeof json.battery.voltage === 'number' || (typeof json.battery.voltage === 'string' && !isNaN(Number(json.battery.voltage)))) ? Number(json.battery.voltage) : 0,
										versionId: '0.0.001',
									});
								}

								await this.axios.post('/data/batch', batch);
							}

							return true;
						}
					}
				];
			},
			_organisations() {
				return this.organisations.map(val => {
					return {
						label: val.label,
						value: val.id,
					};
				});
			},
		},
		async created() {
			console.log('m', this.model);
			this.m = {...this.m, ...this.model};

			this.organisations = (await this.axios.get('/organisations?_size=1000')).data.content;
		}
	}
</script>

<style lang="scss" scoped>

</style>
